import { IOrder, IOrderUpdate } from '@/store/modules/OrderModule';
import ApiService from './base/ApiService';

export default class OrderService extends ApiService<IOrder, IOrderUpdate> {
  constructor() {
    super('orders');
  }
}
